import React from 'react';
import styled, { css } from 'styled-components';
import { breakpointsMinWidth } from '../../../../../../../common/styling';

const SlideWrap = styled.div`
  border: 1px solid #cfd8dc;
  grid-area: 1/-1;
  transition: ${(props) =>
    props.tabChange ? 'none' : 'all 0.5s cubic-bezier(.48,-0.04,.53,1.06)'};
  border-radius: 8px;

  ${(props) => {
    const { offset, dir } = props;

    const absOffset = Math.abs(offset);

    const shift = `${80 * offset}%`;
    const rotateAngle = `${12 * dir}deg`;
    const scaleFactor = 1 - absOffset / 4;
    const displayOffsetCard = absOffset > 1 ? '0' : '1';

    return css`
      transform: translateX(${shift}) rotateY(${rotateAngle});
      scale: ${scaleFactor};
      opacity: ${displayOffsetCard};
    `;
  }}

  ${(props) => {
    const { active, tiltx, tilty } = props;
    if (active) {
      return css`
        &:hover {
          transition: none;
          transform: rotateY(${tiltx}) rotateX(${tilty});
        }
      `;
    }
    return css``;
  }}

    @media ${breakpointsMinWidth.tabletMd} {
    ${(props) => {
      const { offset, dir } = props;

      const absOffset = Math.abs(offset);
      const displayOffsetCard = absOffset > 2 ? '0' : '1';
      const shift = `${90 * offset}%`;
      const rotateAngle = `${12 * dir}deg`;

      return css`
        transform: translateX(${shift}) rotateY(${rotateAngle});
        opacity: ${displayOffsetCard};
      `;
    }}
  }
  @media ${breakpointsMinWidth.tabletSm} {
    ${(props) => {
      const { offset } = props;

      const absOffset = Math.abs(offset);
      const scaleFactor = 1 - absOffset / 5;

      return css`
        scale: ${scaleFactor};
      `;
    }}
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

const Slide = ({
  slide,
  key,
  offset,
  active,
  dir,
  tiltx,
  tilty,
  tabChange,
}) => {
  const { imageUrl, name } = slide;

  return (
    <SlideWrap
      tabChange={tabChange}
      id={active ? 'activeCard3d' : ''}
      key={key}
      offset={offset}
      active={active}
      dir={dir}
      tiltx={tiltx}
      tilty={tilty}
    >
      <Image loading="lazy" src={imageUrl} alt={`${name} template`} />
    </SlideWrap>
  );
};

export default Slide;
